import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { isNil } from 'ramda'
import { PWM } from 'utils/constants'
import { getConfigOutputValues } from 'components/vehicles/Summary/ChecPlusVehicleSummary/AddRemoveVehicleFeatures/utils'
import { ReadOnlyParameterValue } from 'components/feature/NavigatorPanes/editors/base'
import {
  StyledList,
  StyledParagraph,
  ReadOnlyContainer,
} from './ConfigurationTemplate.style'

const ConfigurationTemplate = ({ configDetails }) => {
  const { polarity } = configDetails
  const outputValues = getConfigOutputValues(configDetails)
  const configHeader =
    polarity === PWM
      ? strings.an_output_pin_with_a_pwm_polarity_config_can_only_have_one_feature_associated_with
      : strings.an_output_pin_can_be_associated_with_multiple_features_if

  return (
    <>
      <StyledParagraph size="medium">{configHeader}</StyledParagraph>
      {polarity !== PWM && (
        <StyledList>{strings.feature_configuration_details()}</StyledList>
      )}
      <ReadOnlyContainer>
        {outputValues.map(
          ({ label, value: val }) =>
            !isNil(val) && (
              <ReadOnlyParameterValue key={label} label={label} value={val} />
            )
        )}
      </ReadOnlyContainer>
    </>
  )
}

ConfigurationTemplate.propTypes = {
  configDetails: PropTypes.shape({
    current: PropTypes.number,
    polarity: PropTypes.string,
    type: PropTypes.string,
    moduleType: PropTypes.string,
    activeStateRange: PropTypes.array,
    description: PropTypes.string,
    location: PropTypes.string,
    connector: PropTypes.string,
    mappedOutputId: PropTypes.string,
    outputDescription: PropTypes.string,
    id: PropTypes.string,
    fnId: PropTypes.string,
    operator: PropTypes.number,
    value: PropTypes.number,
    switchNumber: PropTypes.string,
    switchDescription: PropTypes.string,
    scalingQuery: PropTypes.string,
    startBit: PropTypes.number,
    numberOfBits: PropTypes.number,
    floatingCircuit: PropTypes.string,
  }),
}

export default ConfigurationTemplate
